module.exports = __webpack_public_path__ + "assets/img/mo-poster-layer-12-7a7851a6.png";